/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PropertyIdSetupBody model module.
 * @module model/PropertyIdSetupBody
 * @version 1.0.0
 */
export class PropertyIdSetupBody {
  /**
   * Constructs a new <code>PropertyIdSetupBody</code>.
   * @alias module:model/PropertyIdSetupBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertyIdSetupBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertyIdSetupBody} obj Optional instance to populate.
   * @return {module:model/PropertyIdSetupBody} The populated <code>PropertyIdSetupBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertyIdSetupBody();
      if (data.hasOwnProperty('espId'))
        obj.espId = ApiClient.convertToType(data['espId'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} espId
 */
PropertyIdSetupBody.prototype.espId = undefined;

